const userAgent = () => {
  const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
  const isAndroid = /(Android|Linux)/i.test(navigator.platform);

  if (isMacLike) {
    document.documentElement.classList.add('is-mac');
  } else if (isAndroid) {
    document.documentElement.classList.add('is-android');
  }
};

export {userAgent};
